// Modules
import * as Yup from 'yup'

// Application
import { federalTaxIdValidator } from 'utils'

export const FederalTaxIdSchema = Yup.object().shape({
    username: Yup.string()
        .required('Campo obrigatório')
        .test('username', 'CPF inválido', (value: string | undefined): boolean =>
            value?.length === 14 ? federalTaxIdValidator(value) : true,
        ),
})

export const CPFSchema = Yup.object().shape({
    username: Yup.string()
        .required('Campo obrigatório')
        .test('username', 'CPF inválido', (value: string | undefined): boolean => federalTaxIdValidator(value)),
})
